import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FullImgCardModel {
  src: any;
  isSelected?: boolean;
  isReportImage?: boolean;
  imageId?: string;
  patientRecordCaseId?: string;
}

@Component({
  selector: 'app-full-img-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './full-img-card.component.html',
  styleUrl: './full-img-card.component.scss'
})
export class FullImgCardComponent {

  @Input() image: FullImgCardModel;

  @Output() onCloseIconClick = new EventEmitter<boolean>();

  closeFullscreenImage() {
    this.onCloseIconClick.emit(true);
  }
}
